import { createActionWithPayload } from './utils';

export const ACTIONS = {
  SET_SP_AUTO_SUBMIT_SHEET: 'SET_SP_AUTO_SUBMIT_SHEET',
} as const;

export const setSPAutoSubmitSheet = createActionWithPayload<
  typeof ACTIONS.SET_SP_AUTO_SUBMIT_SHEET,
  { autoSubmitSheet: boolean }
>(ACTIONS.SET_SP_AUTO_SUBMIT_SHEET);
